export default __webpack_public_path__ + "static/media/champagne.54155bb6.jpg";